import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { HttpCalendarService } from "@root/component/multi-calendar/http-calendar.service";
import { PlatformType } from "@root/config";
import { NzMessageService } from "ng-zorro-antd/message";
import { CtripPriceFormService } from "../../operate-sidebar/ctrip-price-form/ctrip-price-form.service";
import _ from "lodash";
import * as moment from "moment";
import { TranslateService } from "@root/shared/service/translate.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { DateService } from "@root/shared/service/date.service";
import { HttpClient } from "@angular/common/http";
import { forkJoin } from "rxjs";
import { MultiHouseCalendarService } from "../../calendar/multi-house-calendar/multi-house-calendar.service";
import { ModalService } from "@root/router/index/modal.service";
@Component({
  selector: "host-hostex-price",
  templateUrl: "./hostex-price.component.html",
  styleUrls: ["./hostex-price.component.scss"],
})
export class HostexPriceComponent implements OnInit {
  // @Input() nights;
  @Input() dateRange: Array<string | Date> = [];
  // @Input() id;
  @Input() listOfForbiddenDates = [];
  @Input() set listOfHouse(value) {
    this.property = value?.find((item) => item.type === "house") || value?.find((item) => item.type === "type");
    this.formatCheckboxOptions(value);
  }
  @Input() set listOfPrice(value) {
    this.formatListOfPrice(value);
  }
  @Output() success = new EventEmitter();
  @Output() onCheckboxChange = new EventEmitter();
  nzFormat = this.dateService.getAngularFormat(["YMD"]);
  listOfCheckboxOptions = [];
  listOfPriceByThirdparty = [];
  listOfChannelRatio = [];

  /**
   * 当前关联的房源，可能是 house 或者 room type
   * 对于独立房源来说，该值为 house，即在 hostex 中创建的房源
   * 对于房型来说，该值既可能是 house 也可能是 room type；当房型添加的房源为 hostex 中创建的房源时，该值为 house，否则是房型本身
   */
  property;

  hasCtrip = false;

  _price; // 一键改价
  get price() {
    return this._price;
  }

  set price(val) {
    this._price = val;
    this.listOfPriceByThirdparty
      .filter((item) => !item.readonly)
      .forEach((item) => {
        item.price = this.calculateChannelRatioPrice(item.thirdparty_type, this.price);

        if (this.isCtrip(item.thirdparty_type)) {
          this.recalculateCtripPrice(item);
        }
      });
    // _.forEach(this.listOfPriceByThirdparty, (item) => {

    // });
  }

  get nights() {
    return moment(this.dateRange[1]).diff(moment(this.dateRange[0]), "d") + 1;
  }

  disabledDate = (date: Date) => {
    const format = moment(date).format("YYYY-MM-DD");

    const head = moment().subtract(1, "d");
    const last = moment().add(24, "month");
    // const head = moment().subtract(90, 'd');
    // const last = moment().add(90, 'd');

    return !moment(date).isBetween(head, last, "d");
  };
  constructor(
    private messageService: NzMessageService,
    private houseCalendarService: MultiHouseCalendarService,
    private httpService: HttpCalendarService,
    private ctripPriceFormService: CtripPriceFormService,
    private translate: TranslateService,
    private dateService: DateService,
    private http: HttpClient,
    private modal: ModalService,
  ) {}

  ngOnInit() {
    this.fetchChannelPriceRatio();
  }

  private fetchChannelPriceRatio() {
    forkJoin([
      this.http.get("/api/setting/channel_price_ratio"),
      this.http.get("/api/thirdparty/had_thirdparty"),
    ]).subscribe((rst: any) => {
      const allChannels = rst[0]?.data?.list ?? [];
      const hadChannels = rst[1]?.data?.had_thirdparty ?? [];
      this.listOfChannelRatio = allChannels.filter((c) => hadChannels.includes(c.thirdparty_type));
      console.log("list of channel: ", this.listOfChannelRatio);
    });
  }

  formatCheckboxOptions(value = []) {
    this.listOfCheckboxOptions = _.map(value, (i) => ({
      label: i.title,
      value: i.id,
      type: i.type,
      checked: true,
    }));
  }

  formatListOfPrice(value = []) {
    console.log("formatListOfPrice: ", value);
    this.listOfPriceByThirdparty = _.map(value, (i) => {
      const result = {
        price: null,
        placeholder: i.min === i.max ? i.min : `${i.min}-${i.max}`,
        // limit: _.clone(PRICE_RANGE[i.thirdparty_type]),
        ...i,
      };

      /**
       * rate plan 价格不可编辑
       */
      if (i.readonly) {
        result.price = null;
        result.placeholder = "N/A";
      }

      if (this.isCtrip(i.thirdparty_type)) {
        result.placeholder = "";

        result.max_reserve_price = i.max;
        result.min_reserve_price = i.min;

        result.init_commission_rate = i.commission_rate;
        result.init_reserve_price = i.reserve_price;
        result.init_sale_price = i.sale_price;

        result.commission_rate = i.commission_rate;
        result.reserve_price = i.min;
        result.sale_price = i.sale_price;

        result.displayCtripPriceForm = false;

        this.hasCtrip = true;
      }

      return result;
    });
    console.log("[hostex price listOfPriceByThirdparty]", this.listOfPriceByThirdparty);
  }

  changeCheckbox() {
    const mapedGroup = this.getHouseAndTypeIds();
    this.onCheckboxChange.emit(mapedGroup);
  }

  private getHouseAndTypeIds() {
    const group = _.groupBy(_.filter(this.listOfCheckboxOptions, "checked"), "type");
    const mapedGroup = _.mapValues(group, (values) => _.map(values, "value"));
    return mapedGroup;
  }

  changeDate(value) {
    const head = moment(_.head(value));
    const last = moment(_.last(value)).subtract(1, "d");
  }

  checkDateIsInRange() {
    const end = _.last(this.dateRange);
    const endLimit = moment().add(6, "month");

    if (endLimit.isAfter(end, "d")) {
      return true;
    }
    // 仅可操作7个月内的日期
    const warningText = this.translate.syncGet("warning.available_within_seven_months");
    this.messageService.info(warningText);
    return false;
  }

  onDisplayListingPr() {
    if (this.property.type === "type") {
      this.modal.displayRoomTypeDetailDrawer(this.property.id, 2);
    } else {
      this.modal.displayPropertyDetailDrawer(this.property.id, 2);
    }
  }

  onClickCancel() {
    this.success.emit();
  }

  @WritePermissionGurd("calendar")
  onClickSave() {
    // if (!this.checkDateIsInRange()) {
    //   return;
    // }

    this.requestUpdatePriceBatch();
  }

  @WritePermissionGurd("calendar")
  requestUpdatePriceBatch() {
    const group = this.getHouseAndTypeIds();

    const format = "v_2";
    const house_ids = group.house || [];
    const house_type_ids = group.type || [];
    const begin = moment(_.head(this.dateRange)).format("YYYY-MM-DD");
    const end = moment(_.last(this.dateRange)).format("YYYY-MM-DD");
    const price_list = _.map(
      _.filter(this.listOfPriceByThirdparty, (p) => p.price !== null),
      (item) => {
        const result = {
          origin_house_id: item.origin_house_id,
          thirdparty_type: item.thirdparty_type,
          currency: item.currency,
          price: item.price,
        };

        if (this.isCtrip(item.thirdparty_type)) {
          _.assign(result, {
            sale_price: item.sale_price,
            reserve_price: item.reserve_price,
            commission_rate: item.commission_rate,
            payment_type: item.payment_type,
            type: "sale_price",
          });
        }

        return result;
      },
    );

    console.log("price_list: ", price_list);

    this.httpService
      .editHousePriceBatch({
        format,
        house_ids,
        house_type_ids,
        begin,
        end,
        price_list,
      })
      .subscribe((res) => {
        if (res && res.error_code === 0) {
          this.refreshCalendar();
          this.success.emit();
        }
      });
  }

  refreshCalendar() {
    this.houseCalendarService.calendarRefreshRaw$.next(null);
  }

  // hasWritePermission() {
  //   return this.authorityService.hasWritePermission("calendar");
  // }

  onClearCtripPriceForm(form) {
    form.price = null;
    form.placeholder = "";

    form.reserve_price = form.init_reserve_price;
    form.sale_price = null;

    form.displayCtripPriceForm = false;
  }

  onConfirmCtripPriceForm(form, data) {
    console.log("form: ", form);
    console.log("data: ", data);

    form.commission_rate = data.commission / 100;
    form.sale_price = data.salePrice;
    form.reserve_price = data.reservePrice;
    form.price = data.salePrice;

    form.displayCtripPriceForm = false;
  }

  isCtrip(thirdparty) {
    return +thirdparty === PlatformType.Ctrip;
  }

  ctripReservePriceText(data) {
    if (_.isNil(data.price)) {
      return data.max_reserve_price === data.min_reserve_price
        ? data.min_reserve_price
        : `${data.min_reserve_price}~${data.max_reserve_price}`;
    }

    return data.reserve_price;
    // return this.calculateReservePrice(data.commission_rate * 100, data.price);
  }

  recalculateCtripPrice(data) {
    data.reserve_price = this.calculateReservePrice(data.commission_rate * 100, data.price);
    data.sale_price = data.price;
  }
  private calculateChannelRatioPrice(channel, price) {
    const item = this.listOfChannelRatio.find((c) => c.thirdparty_type === channel);
    return (price * (item?.ratio ?? 100)) / 100;
  }

  private calculateReservePrice(commission, salePrice) {
    return this.ctripPriceFormService.calculateReservePrice(commission, salePrice);
  }
}
